import { User } from './user';

export class Resource {
  id: String;
  parentId?: number;
  createdOn: Date;
  updatedOn: Date;
  createdBy: User;
  lastModifiedBy: User;
}
